export default "__VITE_PUBLIC_ASSET__3fe913fb__"